import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function Eye({
  color = 'icon.primary',
  fill = 'transparent',
  strokeWidth = '1.5',
  ...props
}) {
  return (
    <IconBase viewBox='0 0 20 14' {...props}>
      <Path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M1.75192 7.64342C1.60613 7.39844 1.60613 7.10127 1.75192 6.8563C3.50883 3.91071 6.75427 1.35742
           9.99972 1.35742C13.2452 1.35742 16.4906 3.91071 18.2475 6.85714C18.3933 7.10212 18.3933 7.39928
           18.2475 7.64426C16.4906 10.5898 13.2452 13.1431 9.99972 13.1431C6.75427 13.1431 3.50883 10.5898
           1.75192 7.64342Z'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={strokeWidth}
        fill={fill}
      />
      <Path
        d='M11.8174 5.58297C12.8216 6.50349 12.8216 7.99595 11.8174 8.91647C10.8132 9.83699 9.18509 9.83699
      8.18089 8.91647C7.17668 7.99595 7.17668 6.50349 8.18089 5.58297C9.18509 4.66245 10.8132 4.66245
      11.8174 5.58297'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={strokeWidth}
        fill={fill}
      />
    </IconBase>
  )
}

Eye.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
  strokeWidth: PropTypes.string,
}

export default Eye
